export default "__VITE_ASSET__BcAQDbar__"